export default __webpack_public_path__ + "8208e0d26de869b225a335b36dab1f65.svg";